<div class="app-wrapper" [ngClass]="homePage ? 'vh-100' : ''">
  <app-navigation></app-navigation>
  <div class="container">
    <router-outlet></router-outlet>
  </div>
</div>
